import React, { Component } from 'react';
import { Menu } from 'element-react';
import './NoticiaCard.css';

class NoticiaCard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
    this.edit = this.edit.bind(this);
  }

  edit(id) {
    this.props.edit(id);  
  }

  delete() {
    // if (window.confirm("Estás segur que vols borrar la noticia?")) { 
    //   this.props.delete();
    // }
    if (window.confirm("Aquesta funcionalitat encara no està disponible")) { 

    }
  }

  render() {
    const { noticia } = this.props;
    const { createdAt } = noticia;
    const formattedDate = `
        ${new Date(createdAt).getDate()}/${new Date(createdAt).getMonth()+1}/${new Date(createdAt).getFullYear()}
        a las ${('0' + new Date(createdAt).getHours()).slice(-2)}:${('0' + new Date(createdAt).getMinutes()).slice(-2)}
      `;

    return (
      <div className="cardWrapper">
        <div className="headerCard">
          <div className="editWrapper">
            <i onClick={() => this.edit(noticia._id)} className="el-icon-edit"></i>
            <i onClick={() => this.delete()} style={{ color: 'red' }} className="el-icon-delete"></i>
          </div>
          <h5>{ formattedDate }</h5>
        </div>
        <div className="content">
          <h3>Título: {noticia.esTitle}</h3>
          <p>
            Mensaje:<br />
            {noticia.esMessage}
          </p>
        </div>
        <div className="content">
          <h3>Títol: {noticia.catTitle}</h3>
          <p>
            Missatge:<br />
            {noticia.catMessage}
          </p>
        </div>
        <div className="content">
          <h3>Title: {noticia.enTitle}</h3>
          <p>
            Message:<br />
            {noticia.enMessage}
          </p>
        </div>
      </div>
    );
  }
}

export default NoticiaCard;



// WEBPACK FOOTER //
// ./src/components/NoticiaCard/NoticiaCard.js